/** @jsxImportSource @emotion/react */
import { Button } from '@coreai/component-library';
import { css, useTheme } from '@emotion/react';
import { useLanguage } from 'LanguageContext';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SuccessLogout = () => {
  const theme = useTheme();
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();

  const Navigate = useNavigate();

  const isLogout = searchParams?.get('page') === 'logout';
  const isUpdatePassword = searchParams?.get('page') === 'update_password';

  useEffect(() => {
    window.localStorage.clear();
  }, [])

  const containerStyle = css`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f4f6;
    padding: 1rem;
  `;

  const contactSectionStyles = css`
    text-decoration: none;
    border-radius: 8px;
    background-color: #fff;
    color: inherit;
    padding: ${theme.spacing.xxl};
    font-size: 20px;
    text-align: center;
    box-shadow: ${theme.shadows.shallow};
    width: 100%;
    max-width: 400px;
  `;

  const buttonStyle = css`
      width: 100%;
      background-color: ${theme.colors.primary};
      color: white;
      padding: 0.5rem;
      border: none;
      border-radius: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s ease;
    `;

  return (
    <div css={containerStyle}>      
      <div css={contactSectionStyles}>
        {isLogout && <p>{t("signout_title")}</p>}
        {isUpdatePassword && <p>{t("update_passowrd_please_login")}</p>}

        <p style={{ margin: '1.5rem 0' }}>{t("signout_please_login")}</p>

        <Button type="submit" css={buttonStyle} onClick={() => Navigate('/signin')}>
          {t("signout_login_link")}
        </Button>
      </div>
    </div>
  );
};

export default SuccessLogout;